/**
 * Animation Icons - scroll trigger animations
 */

document.addEventListener('DOMContentLoaded', function() {
    console.log('Animation icons script loaded');
    
    const icons = document.querySelectorAll('.animation-icon');
    console.log('Found icons:', icons.length);
    
    if (icons.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                console.log('Icon observed:', entry.target, 'isIntersecting:', entry.isIntersecting);
                if (entry.isIntersecting) {
                    console.log('Adding in-view class to:', entry.target);
                    entry.target.classList.add('in-view');
                    // Odłącz observer dla tego elementu po animacji
                    observer.unobserve(entry.target);
                }
            });
        }, { 
            threshold: 0.3,
            rootMargin: '0px 0px -20px 0px'
        });

        icons.forEach(icon => {
            console.log('Observing icon:', icon);
            observer.observe(icon);
        });
        
        console.log(`Zainicjalizowano animację dla ${icons.length} ikon`);
    } else {
        console.log('Nie znaleziono elementów .animation-icon');
    }
});
